<form  [formGroup] = "subdivisionForm">
  <h1 *ngIf ="mode ==1" mat-dialog-title> Editing {{data.subdivision_name || '[[no name sub]]'}}</h1>
  <h1 *ngIf ="mode ==2" mat-dialog-title> Add Subdivision </h1>


  <div id="tagModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Would you like to add {{currentAddedTagName}} tag to all previously created locations?</p>
      <p *ngIf="isMfProjectTag(currentAddedTagID)" style="color: #424242;font-size: 0.9em;">This tag will also be applied to all other buildings in this MF project.</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleModalResponse(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleModalResponse(false)">No</button>
    </div>
  </div>


  <div id="tagModalRemove" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Would you like to remove {{currentRemovedTagName}} tag from all previously created locations?</p>
      <p *ngIf="isMfProjectTag(currentRemovedTagID)" style="color: #424242;font-size: 0.9em;">This tag will also be removed from all other buildings in this MF project.</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleModalResponseDelete(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleModalResponseDelete(false)">No</button>
    </div>
  </div>


  <div id="massUpdateModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Update the {{massUpdatePromptLabels}} for all previously existing locations in this subdivision?</p>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleMassUpdateResponse(true)">Yes</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleMassUpdateResponse(false)">No</button>
    </div>
  </div>


  <div mat-dialog-content *ngIf ="mode%3 > 0" fxLayout.xs="column" style="width:95%; text-align:center" >
  <br>

  <mat-tab-group>

        <mat-tab label = "Details" >

    <div class="subdiv-edit-form">

    <!-- Identity ------------------------------------------------------------- -->
    <mat-form-field>
      <mat-label>Subdivision Name:</mat-label>
      <input matInput formControlName = "subdivision_name">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Builder: {{data.customer_name}}</mat-label>
      <input  #buildername matInput formControlName = "customer_id" [matAutocomplete] = "builderauto">
    </mat-form-field>
    <!-- autocomplete renders in an overlay; position here is irrelevant to layout -->
    <mat-autocomplete #builderauto = "matAutocomplete" (optionSelected) = "onSelectBuilder($event.option.value)" [displayWith]="displayFunctionBuilder">
      <mat-option *ngFor="let customer of (builder$ | async)" [value]="customer">
        <span>{{ customer.customer_name}}</span>
      </mat-option>
    </mat-autocomplete>

    <div class="subdiv-check">
      <mat-checkbox labelPosition="before" formControlName = "townhomes">Townhomes</mat-checkbox>
    </div>

    <div class="subdiv-check" style="display: flex; align-items: center;">
      <mat-checkbox labelPosition="before" formControlName = "ismultifamily">Multi-Family</mat-checkbox>
      <mat-form-field style="width: 120px; margin-left: 1.5em;">
        <mat-label>Number of Units</mat-label>
        <input matInput type="number" formControlName="num_units">
      </mat-form-field>
      <mat-form-field style="width: 170px; margin-left: 1.5em;">
        <mat-label>Number of Stories</mat-label>
        <mat-select formControlName="story_type">
          <mat-option value="">-- None --</mat-option>
          <mat-option *ngFor="let st of storyTypes" [value]="st">{{st}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- isbillingbldg stays a live form control (auto-ticked by applyBillingBldgDefault and
         saved with the form) but is not shown; the user never needs to touch it. -->
    <div class="subdiv-check" *ngIf="subdivisionForm.get('ismultifamily').value" style="display: flex; align-items: center; gap: 1.5em;">
      <mat-checkbox formControlName="isbillingbldg" style="display: none;"></mat-checkbox>
      <button type="button" class="mf-contacts-btn" [class.mf-contacts-btn--filled]="mfContactCount > 0"
              [disabled]="mode != 1" (click)="openMfContactsDialog()">{{mfContactsLabel}}</button>
      <span *ngIf="mode != 1" style="color: #9e9e9e; font-size: 0.85em;">Save the subdivision first</span>
    </div>

    <mat-form-field>
      <mat-label>HVAC Contractor: {{hvacDisplay || ''}}</mat-label>
      <input  #custname matInput formControlName = "dhvaccontractor" [matAutocomplete] = "custauto">
    </mat-form-field>
    <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectCustomer($event.option.value)" [displayWith]="displayFunctionContractor">
      <mat-option *ngFor="let customer of (customer$ | async)" [value]="customer">
        <span>{{ customer.customer_name}}</span>
      </mat-option>
    </mat-autocomplete>

    <!-- Location -------------------------------------------------------------- -->
    <div style="display:flex; align-items:center; gap:0.5em;">
      <mat-form-field style="flex:1 1 0; min-width:0;">
        <mat-label>City: {{data.city}}</mat-label>
        <input  #cityname matInput formControlName='city' [matAutocomplete] = "cityauto" [placeholder]="(this.data.city || '')">
      </mat-form-field>
      <button *ngIf="data.city" (click)="clearCity()">Clear</button>
    </div>
    <div matRipple [matRippleDisabled]="true" #cityRipple>
      <mat-autocomplete #cityauto = "matAutocomplete" (optionSelected) = "onSelectCity($event.option.value)" [displayWith]="displayFunction">
        <mat-option *ngFor="let city of (city$ | async)" [value]="city">
          <span>{{ city.lister}}</span>
        </mat-option>
      </mat-autocomplete>
    </div>

    <div class="subdiv-row">
      <div matRipple [matRippleDisabled]="true" #regionRipple class="subdiv-cell">
        <mat-form-field>
          <mat-label> Region </mat-label>
          <mat-select  formControlName = "region">
            <mat-option *ngFor = "let region of regions" [value] = "region.value">
              {{region.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Builder Region</mat-label>
        <input matInput formControlName = "bldr_region">
      </mat-form-field>
    </div>

    <div class="subdiv-row">
      <div matRipple [matRippleDisabled]="true" #stateRipple class="subdiv-cell">
        <mat-form-field>
          <mat-label> State </mat-label>
          <mat-select  style="color:white !important;" formControlName = "state">
            <mat-option style="color:white !important;" *ngFor = "let state of states" [value] = "state.value">
              <p style="color:white !important;">{{state.viewValue}}</p>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Zip:</mat-label>
        <input (blur)="updateClimateZone()" matInput formControlName = "dzip">
      </mat-form-field>
    </div>

    <div class="subdiv-row">
      <div matRipple [matRippleDisabled]="true" #elevationRipple class="subdiv-cell" style="overflow: visible !important;">
        <mat-form-field>
          <mat-label>Elevation:</mat-label>
          <input matInput formControlName = "elevation">
        </mat-form-field>
      </div>
      <div matRipple [matRippleDisabled]="true" #defaultczRipple class="subdiv-cell" style="overflow: visible !important;">
        <mat-form-field>
          <mat-label>CZ:</mat-label>
          <input matInput formControlName = "cz" (change)="checkACE()">
        </mat-form-field>
      </div>
    </div>

    <!-- Scopes & Pathways ----------------------------------------------------- -->
    <!-- MF scope filter, driven by scopedef.category. Checked = only Multifamily
         scopes; unchecked = every active scope. Flips both scope dropdowns. -->
    <div class="subdiv-check">
      <mat-checkbox [(ngModel)]="showMultifamilyScopes" [ngModelOptions]="{standalone: true}">
        Multi-family scopes only
      </mat-checkbox>
    </div>

    <!-- Scope 1 + its pathways (add as many as needed) -->
    <div class="subdiv-row">
      <mat-form-field>
        <mat-label>Scope:</mat-label>
        <mat-select matNativeControl formControlName="scope" (selectionChange)="onSelectScope($event.value, 'scope')">
          <mat-option *ngFor="let scope of visibleScopes" [value]="scope.scope">
            {{scope.scope}}</mat-option>
          <mat-option value="0">++ New Scope ++</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="subdiv-spacer"></div>
    </div>

    <div class="subdiv-paths" formArrayName="scope1paths">
      <span class="subdiv-paths-label">Pathways:</span>
      <div class="subdiv-path-row" *ngFor="let ctrl of scope1pathsArray.controls; let i = index">
        <mat-form-field>
          <mat-label>Pathway {{i + 1}}:</mat-label>
          <mat-select [formControlName]="i">
            <mat-option *ngFor="let p of pathways" [value]="p">{{p}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-icon-button type="button" color="warn" title="Remove pathway" (click)="removePathway('scope1paths', i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <button mat-stroked-button type="button" (click)="addPathway('scope1paths')">+ Add pathway</button>
    </div>

    <!-- Scope 2 + its pathways -->
    <div class="subdiv-row">
      <mat-form-field>
        <mat-label>Scope 2:</mat-label>
        <mat-select matNativeControl formControlName="scope2" (selectionChange)="onSelectScope($event.value, 'scope2')">
          <mat-option value="">-- None --</mat-option>
          <mat-option *ngFor="let scope of visibleScopes" [value]="scope.scope">
            {{scope.scope}}</mat-option>
          <mat-option value="0">++ New Scope ++</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="subdiv-spacer"></div>
    </div>

    <div class="subdiv-paths" formArrayName="scope2paths">
      <span class="subdiv-paths-label">Pathways:</span>
      <div class="subdiv-path-row" *ngFor="let ctrl of scope2pathsArray.controls; let i = index">
        <mat-form-field>
          <mat-label>Pathway {{i + 1}}:</mat-label>
          <mat-select [formControlName]="i">
            <mat-option *ngFor="let p of pathways" [value]="p">{{p}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-icon-button type="button" color="warn" title="Remove pathway" (click)="removePathway('scope2paths', i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <button mat-stroked-button type="button" (click)="addPathway('scope2paths')">+ Add pathway</button>
    </div>

    <!-- Scope 3 + its pathways -->
    <div class="subdiv-row">
      <mat-form-field>
        <mat-label>Scope 3:</mat-label>
        <mat-select matNativeControl formControlName="scope3" (selectionChange)="onSelectScope($event.value, 'scope3')">
          <mat-option value="">-- None --</mat-option>
          <mat-option *ngFor="let scope of visibleScopes" [value]="scope.scope">
            {{scope.scope}}</mat-option>
          <mat-option value="0">++ New Scope ++</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="subdiv-spacer"></div>
    </div>

    <div class="subdiv-paths" formArrayName="scope3paths">
      <span class="subdiv-paths-label">Pathways:</span>
      <div class="subdiv-path-row" *ngFor="let ctrl of scope3pathsArray.controls; let i = index">
        <mat-form-field>
          <mat-label>Pathway {{i + 1}}:</mat-label>
          <mat-select [formControlName]="i">
            <mat-option *ngFor="let p of pathways" [value]="p">{{p}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-icon-button type="button" color="warn" title="Remove pathway" (click)="removePathway('scope3paths', i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <button mat-stroked-button type="button" (click)="addPathway('scope3paths')">+ Add pathway</button>
    </div>

    <div class="subdiv-row">
      <mat-form-field style="flex: 1 1 100%;">
        <mat-label>Sticker Location:</mat-label>
        <textarea matInput rows="3" formControlName="stickerlocation"></textarea>
      </mat-form-field>
    </div>

    <div class="subdiv-row">
      <mat-form-field style="flex: 1 1 100%;">
        <mat-label>Envelope Specs:</mat-label>
        <textarea matInput rows="3" formControlName="envspecs"></textarea>
      </mat-form-field>
    </div>

    <div class="subdiv-row">
      <mat-form-field>
        <mat-label>Longitude:</mat-label>
        <input matInput formControlName = "lng">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Latitude:</mat-label>
        <input matInput formControlName = "lat">
      </mat-form-field>
    </div>

    <div class="subdiv-row">
      <mat-form-field>
        <mat-label>Price Adder:</mat-label>
        <input matInput formControlName = "priceadder">
      </mat-form-field>
      <div class="subdiv-spacer"></div>
    </div>

    <div *ngIf='data.areamanager' style="padding-top: 10px;">
      <mat-label>Area Manager: </mat-label>
      {{data.areamanager}}
    </div>

    <!-- Contacts & Management ------------------------------------------------- -->
    <div style="display:flex; align-items:flex-start; gap:1.5em; margin: 0.5em 0;">
      <div style="flex:1 1 0; min-width:0; display:flex; align-items:center; gap:0.5em;">
        <mat-form-field style="flex:1 1 0; min-width:0;">
          <mat-label>Contact: {{data.contact}}</mat-label>
          <input matInput formControlName = "contact" #areaman [matAutocomplete] = "contactauto">
        </mat-form-field>
        <button *ngIf="data.contact" (click)="clearContact()">Clear</button>
      </div>
      <div>
        <mat-label> Update All? </mat-label>
        <br>
        <mat-checkbox formControlName = "updateall"></mat-checkbox>
      </div>
    </div>
    <mat-autocomplete #contactauto = "matAutocomplete" (optionSelected) = "onSelectContact($event.option.value)" [displayWith]="displayFunctionContact">
      <mat-option *ngFor="let contact of (contact$ | async)" [value]="contact">
        <span>{{contact.name}}</span>
      </mat-option>
    </mat-autocomplete>

    <div class="subdiv-row">
      <mat-form-field>
        <mat-label>Area Manager:</mat-label>
        <input matInput formControlName = "areamanager">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Area Manager Email:</mat-label>
        <input matInput formControlName = "areamanemail">
      </mat-form-field>
    </div>

    <!-- Utilities & Options --------------------------------------------------- -->
    <div class="subdiv-row">
      <mat-form-field>
        <mat-label> Gas Utility </mat-label>
        <mat-select  formControlName = "gasutility">
          <mat-option *ngFor = "let utility of gasUtilities" [value] = "utility.company">
            {{utility.company}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label> Electric Utility </mat-label>
        <mat-select  formControlName = "elecutility">
          <mat-option *ngFor = "let utility of elecUtilities" [value] = "utility.company">
            {{utility.company}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="subdiv-check">
      <mat-label> Generator </mat-label>
      <br>
      <mat-checkbox formControlName = "generator"></mat-checkbox>
    </div>

    <div>
      <mat-form-field>
        <mat-label>Consultant: {{employee_name}}</mat-label>
        <input  #consultant matInput [placeholder]="employee_name? employee_name.trim() : '' " formControlName = "consultant" [matAutocomplete] = "employeeauto">
        <button *ngIf="employee_name" matSuffix mat-icon-button aria-label="Clear" (click)="resetEmployeeName(this.data)">
          X
        </button>
      </mat-form-field>
      <mat-autocomplete #employeeauto = "matAutocomplete" (optionSelected) = "onSelectEmployee($event.option.value)" [displayWith]="displayFunctionEmployee">
        <mat-option *ngFor="let em of (employee$ | async)" [value]="em">
          <span>{{ em.employee_name}}</span>
        </mat-option>
      </mat-autocomplete>
    </div>

    <mat-form-field>
      <mat-label>Sub Name:</mat-label>
      <mat-select formControlName="sub_id" (selectionChange)="onSelectSub($event.value)">
        <mat-option [value]="null">-- None --</mat-option>
        <mat-option *ngFor="let sub of subs" [value]="sub.customer_id">
          {{sub.customer_name}}</mat-option>
        <mat-option [value]="0">++ Add a Sub ++</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="subdiv-check">
      <mat-label> Archive </mat-label>
      <br>
      <mat-checkbox formControlName = "archive"></mat-checkbox>
    </div>

    <div class="subdiv-check">
      <mat-label>Override Scope when selecting jobs?  </mat-label>
      <br>
      <mat-checkbox formControlName = "overridesc"></mat-checkbox>
    </div>

    </div>

        </mat-tab>
        <mat-tab label="Tags">


          <div style="display: flex;
          width: 90%;
          height: 200px;
          margin-top: 30px;
          align-content: flex-start;
          flex-wrap: wrap;
          justify-content: space-evenly;">
          <mat-form-field style="width:85%;">
            <mat-chip-list #chipList>
              <mat-chip *ngFor="let tag of inputTags" [selectable]="true" [removable]="true" (removed)="removeTag(tag)">
                {{tag ? tag.displayname: ''}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input placeholder="Add tag..."
                     [matAutocomplete]="auto"
                     [matChipInputFor]="chipList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     (matChipInputTokenEnd)="addTag($event)"
                     (keyup.enter)="onEnter(auto)"
                     formControlName="tagControl">
            </mat-chip-list>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTag($event, $event.option.value)">
              <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
                {{tag.displayname}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

          <!-- MF / SF / GPS tag-type filter. None ticked = show all. -->
          <div style="display:flex; gap:1em; margin-bottom:0.5em; align-items:center;">
            <span style="color:#757575; font-size:0.9em;">Show:</span>
            <mat-checkbox *ngFor="let t of tagService.TAG_TYPES"
                          [checked]="tagTypeFilter.includes(t)"
                          (change)="toggleTagType(t)">{{t}}</mat-checkbox>
          </div>

          <div style="height: 200px;">
          <mat-chip-list>
            <mat-chip *ngFor="let tag of visibleTags" (removed)="removeTag(tag)" (click)="addTag($event, tag)" matTooltip="{{tag.description}}">{{tag.displayname}}</mat-chip>
          </mat-chip-list>

        </div>


        </mat-tab>
      </mat-tab-group>

  </div>

  <div class ="" mat-dialog-actions>
    <button mat-button (click)="close()" >Close</button>

    <button *ngIf ="mode ==1" mat-button (click)="save()"  cdkFocusInitial>Save</button>
    <button *ngIf ="mode ==2" mat-button (click)="add()" cdkFocusInitial>Add </button>

  </div>
  </form>
